import {Repository, createRepository} from '@/repositories/Base/Repository'

class MethodRepository extends Repository {
    endpoint = 'tuevs/methods'

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }
}

export default new MethodRepository()

export const create = createRepository(MethodRepository)
